import React, { useEffect, useState } from "react";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import axios from "axios";
import { base_url } from "../../context/Authcontext";
import { ChevronDown } from 'lucide-react';
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";



const SportsBets = () => {
  const [isSidebar, setSidebar] = useState(false);
  const location= useLocation();
  const [active,setActive]=useState(location?.state?.active || 0);
  const [data, setData] = useState([]);
  
  // const [resultData , setresultData] = useState([]); 
  

  useEffect(() => {
    const sportData = async () => {
        try {
            const response = await axios.get(base_url + '/api/webapi/sportData', {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            });
            // Handle the response data here
            console.log("Response data:", response.data);
            setData(response.data); // Now this will work
        } catch (error) {
            console.error("Error fetching sport data:", error);
            // Handle the error appropriately
        }
    };

    

  

  const history= async()=>{
    const gameToken=localStorage.getItem('game_token');
    const response=await axios.get(base_url + '/api/webapi/casinoHistory',
      {params:{
        gameToken
      },
        withCredentials:true,
        headers:{
          'content-type':'application/json',
        }
      }
    )

    // console.log('history',response);
  }



    history();

    
    sportData(); // Call the async function
  }, []);


  return (
    <>
      {isSidebar && <Sidebar />}
      <div style={{background:'#fff'}}>
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-tgc-c107=""
        className="content"
        style={{ height: "100vh" }}
      >
        <reports-top-nav _nghost-tgc-c127="">
          <ul
            _ngcontent-tgc-c127=""
            className="popular-tab custom-scrollbar pt-3 pb-2 mt-lg-0 mt-5 px-2"
          >
          
            <li
              _ngcontent-tgc-c127=""
              routerlinkactive="active"
              className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${active===0?'active':''}`}
              tabIndex="0"
              onClick={()=>setActive(0)}
              
            >
              {" "}
              Sports Bets{" "}
            </li>
            <li
              _ngcontent-tgc-c127=""
              routerlinkactive="active"
              className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${active===1?'active':''}`}
              tabIndex="0"
              onClick={()=>setActive(1)}
            >
              {" "}
              Casino Bets{" "}
            </li>
            <li
              _ngcontent-tgc-c127=""
              routerlinkactive="active"
              className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${active===2?'active':''}`}
              tabIndex="0"
              onClick={()=>setActive(2)}
            >
              {" "}
              Fancy Bets{" "}
            </li>
            <li
              _ngcontent-tgc-c127=""
              routerlinkactive="active"
              className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${active===3?'active':''}`}
              tabIndex="0"
              onClick={()=>setActive(3)}
              
            >
              {" "}
              Account Statement{" "}
            </li>

            <li
              _ngcontent-tgc-c127=""
              routerlinkactive="active"
              className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${active===4?'active':''}`}
              tabIndex="0"
              onClick={()=>setActive(4)}
              
            >
              {" "}
              Result{" "}
            </li>
          </ul>
        </reports-top-nav>
        {
            active===0 && <SportsBetsHistory   data={data}/>
        }
        {
            active===1 && <CasinoBetsHistory/>
        }
        {
            active===2 && <FancyBetsHistory/>
        }
        {
            active===3 && <Accountstatement />
        }

        {
            active===4 && <Result />
        }
      </div>
      </div>
    </>
  );
};

const SportsBetsHistory = ({ data }) => {
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);

  React.useEffect(() => {
    const sportData = data?.sportData || [];
    setFilteredData(sportData);
  }, [data]);

  const handleLoadReport = (e) => {
    e.preventDefault();

    const sportData = data?.sportData || [];

    const filtered = sportData.filter((item) => {
      const itemDateStr = item.time || item.date; // e.g., "2025-05-02 15:18:33"
      const itemDate = itemDateStr.split(" ")[0]; // "2025-05-02"

      return (
        (!startDate || itemDate >= startDate) &&
        (!endDate || itemDate <= endDate)
      );
    });

    setFilteredData(filtered);
  };

  return (
    <>
      <div className="mt-3 px-4">
        <form className="row" onSubmit={handleLoadReport}>
          <div className="col-lg-3">
            <p>Start Date:</p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-control date-input bets-form-bg border-warning"
            />
          </div>

          <div className="col-lg-3">
            <p>End Date:</p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="form-control date-input bets-form-bg border-warning"
            />
          </div>

          <div className="align-items-center col-lg-3 d-flex mt-4">
            <button type="submit" className="p-2 rounded-2 w-100 load-btn">
              Load Report
            </button>
          </div>
        </form>
      </div>

      <table className="table-responsive-lg w-100">
        <thead>
          <tr className="p-2 border border-black">
            <th className="text-start text-nowrap border px-3">Tournament Name</th>
            <th className="text-start text-nowrap border px-3">Market Name</th>
            <th className="text-start text-nowrap border px-3">Runner Name</th>
            <th className="text-start text-nowrap border px-3">Side</th>
            <th className="text-start text-nowrap border px-3">Odds</th>
            <th className="text-start text-nowrap border px-3">Price</th>
            <th className="text-start text-nowrap border px-3">Profit/Loss</th>
            <th className="text-start text-nowrap border px-3">Status</th>
            <th className="text-start text-nowrap border px-3">Placed Date</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <tr
                key={index}
                className="border"
                style={{
                  background:
                    item.side === 'Back'
                      ? 'linear-gradient(180deg, #f59dc2, #f5e9ee)'
                      : 'linear-gradient(180deg, #84c2f1, #d9efff)',
                }}
              >
                <td className="text-start px-2 text-black">{item.competitionName}</td>
                <td className="text-start px-2 text-black">{item.eventName}</td>
                <td className="text-start px-2 text-black">{item.runnerName}</td>
                <td className="text-start px-2 text-black">{item.side}</td>
                <td className="text-start px-2 text-black">{item.betprice}</td>
                <td className="text-start px-2 text-black" style={{ fontWeight: '700' }}>{item.betAmount}</td>
                <td className="text-start px-2 text-black" style={{ fontWeight: '700' }}>{item.profit}</td>
                <td className="text-start px-2 text-black">
                 <span style={{
  backgroundColor:
    item.status === 1 ? 'rgb(3, 187, 22)' :      // Win - Green
    item.status === 2 ? 'rgba(255, 0, 0, 1)' :   // Loss - Red
    item.status === 3 ? 'rgba(0, 123, 255, 1)' : // Cashout - Blue
    'rgba(255, 193, 7, 1)',                      // Pending - Yellow
  fontWeight: "700",
  padding: "3px",
  borderRadius: "3px"
}}>
  {
    item.status === 1 ? 'Win' :
    item.status === 2 ? 'Loss' :
    item.status === 3 ? 'Cashout' :
    'Pending'
  }
</span>

                </td>
                <td className="text-start px-2 text-black">{item.date}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

const CasinoBetsHistory = () => {
  const [history, setHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [startDate, setStartDate] = useState("2025-04-04");
  const [endDate, setEndDate] = useState("2025-04-10");

  useEffect(() => {
    const fetchHistory = async () => {
      const response = await axios.get(base_url + '/api/webapi/myCasinoHistory', {
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        }
      });
      const data = response?.data.histry;
      setHistory(data);
      setFilteredHistory(data); // default show all
    };

    fetchHistory();
  }, []);

  const handleFilter = () => {
    const filtered = history.filter((item) => {
      const itemDate = item.time?.split(' ')[0]; // '2025-05-07'
      return itemDate >= startDate && itemDate <= endDate;
    });
    setFilteredHistory(filtered);
  };

  return (
    <>
      <div className="mt-3">
        <form
          className="form-container"
          style={{ display: 'flex', backgroundColor: '#fff', color: "#000", padding: '10px', gap: '10px', width: '100%' }}
          onSubmit={(e) => { e.preventDefault(); handleFilter(); }}
        >
          {/* Start Date */}
          <div style={{ flex: 3.5 }}>
            <p style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>Start Date:</p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{ width: '100%', padding: '10px', border: '1px solid yellow', borderRadius: '2px' }}
            />
          </div>

          {/* End Date */}
          <div style={{ flex: 3.5 }}>
            <p style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>End Date:</p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{ width: '100%', padding: '10px', border: '1px solid yellow', borderRadius: '2px' }}
            />
          </div>

          {/* Load Report */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="submit"
              style={{ width: '100%', backgroundColor: '#ffd800', color: '#000', border: 'none', borderRadius: '4px', padding: '10px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              Load Report
            </button>
          </div>
        </form>
      </div>

      <table className="w-100 table-responsive-md table-responsive-sm">
        <thead>
          <tr className="p-2 bb">
            <th className="text-center border px-3 text-nowrap bb">Game Code</th>
            <th className="text-center border px-3 text-nowrap bb">Game Name</th>
            <th className="text-center border px-3 text-nowrap bb">Round ID</th>
            <th className="text-center border px-3 text-nowrap bb">Runner Name</th>
            <th className="text-center border px-3 text-nowrap bb">Price</th>
            <th className="text-center border px-3 text-nowrap bb">P/L</th>
            <th className="text-center border px-3 text-nowrap bb">Status</th>
            <th className="text-center border px-3 text-nowrap bb">Date</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {filteredHistory.length > 0 ? filteredHistory.map((hist, index) => (
            <tr key={index} className="border" style={{ height: "40px" }}>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">{hist?.gameId}</td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">{hist?.gameCategory}</td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">{hist?.playerGameRoundId}</td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">{hist?.gameProvider}</td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">{hist?.amount}</td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">
                <span style={{ color: hist?.status === 'lose' ? 'red' : 'green' }}>
                  {hist?.profit}
                </span>
              </td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">
                <span style={{ background: hist?.status === 'lose' ? 'red' : 'green', color: 'white', padding: '2px 6px', borderRadius: '4px' }}>
                  {hist?.status}
                </span>
              </td>
              <td style={{ fontSize: "14px" }} className="text-center border px-2 bb">{hist?.time}</td>
            </tr>
          )) : (
            <tr>
              <td colSpan="8" className="text-center border px-2">No data found for selected date range.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};


const FancyBetsHistory = () => {
  const [fancyDataHistory, setFancyDataHistory] = useState([]);
  const [startDate, setStartDate] = useState("2025-04-04");
  const [endDate, setEndDate] = useState("2025-04-10");
  const [filteredData, setFilteredData] = useState([]);

  const fancyHistory = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/getFancyDataHistory", {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });

      const data = response?.data.history;
      setFancyDataHistory(data);

      // If no filters are applied, show all data
      setFilteredData(data);
    } catch (error) {
      console.error("Error loading filtered data:", error);
    }
  };

  useEffect(() => {
    fancyHistory(); // Load default data on mount
  }, []);

  const handleDateFilter = (e) => {
    e.preventDefault();

    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    // Filter the data based on the dates only if both start and end date are present
    if (start && end) {
      const filtered = fancyDataHistory.filter((item) => {
        // Get only the date portion (YYYY-MM-DD) of the backend date
        const itemDate = new Date(item.time).toISOString().split("T")[0]; // Format backend date as "YYYY-MM-DD"

        // Compare the formatted date with the start and end date
        return itemDate >= startDate && itemDate <= endDate;
      });
      setFilteredData(filtered);
    } else {
      // If no filter applied, show all data
      setFilteredData(fancyDataHistory);
    }
  };

  return (
    <>
      <div className="mt-3">
        <form
          className="form-container"
          onSubmit={handleDateFilter}
          style={{
            display: "flex",
            backgroundColor: "#fff",
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Start Date */}
          <div style={{ flex: 1 }}>
            <p style={{ color: "#000", fontSize: "14px", marginBottom: "8px" }}>Start Date</p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid yellow",
                borderRadius: "2px",
              }}
            />
          </div>

          {/* End Date */}
          <div style={{ flex: 1 }}>
            <p style={{ color: "#000", fontSize: "14px", marginBottom: "8px" }}>End Date</p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid yellow",
                borderRadius: "2px",
              }}
            />
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 1, marginTop: "28px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                backgroundColor: "#ffd800",
                color: "#000000",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>
        </form>
      </div>

      {/* Table */}
      <table className="table-responsive-sm table-responsive-md w-100">
        <thead>
          <tr className="p-2 bb">
            <th className="text-center text-nowrap border px-3 bb">Market ID</th>
            <th className="text-center text-nowrap border px-3 bb">Market Name</th>
            <th className="text-center text-nowrap border px-3 bb">Runner Name</th>
            <th className="text-center text-nowrap border px-3 bb">Side</th>
            <th className="text-center text-nowrap border px-3 bb">Value</th>
            <th className="text-center text-nowrap border px-3 bb">Amount</th>
            <th className="text-center text-nowrap border px-3 bb">Placed Date</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <tr
                key={index}
                className="border bg-white"
                style={{
                  height: "40px",
                  background:
                    item.side === "yes"
                      ? "linear-gradient(180deg, #f59dc2, #f5e9ee)"
                      : "linear-gradient(180deg, #84c2f1, #d9efff)",
                }}
              >
                <td className="text-center text-nowrap px-2 bb ml-2">{item.marketId}</td>
                <td style={{ fontSize: "14px" }} className="text-center text-nowrap px-2 bb">
                  <span>{item.competitionName}</span>
                  <span> / </span>
                  <span>{item.eventName}</span>
                  <span> / </span>
                  <span>{item.runnerName}</span>
                  <span> / <strong>Result:</strong> </span>
                  <span>{item.result === "0" ? "Pending" : item.result}</span>
                </td>
                <td className="text-center text-nowrap px-2 bb">{item.rate}</td>
                <td className="text-center text-nowrap px-2 bb">{item.side}</td>
                <td className="text-center text-nowrap px-2 bb">{item.betprice}</td>
                <td className="text-center text-nowrap px-2 bb">{item.value}</td>
                <td className="text-center text-nowrap px-2 bb">
                  {new Date(item.time).toLocaleString()}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};



const Accountstatement = () => {
  const [statement, setStatement] = useState([]);
  const [recharge, setRecharge] = useState([]);
  const [withdraw, setWithdraw] = useState([]);

  const [allStatement, setAllStatement] = useState([]);
  const [allRecharge, setAllRecharge] = useState([]);
  const [allWithdraw, setAllWithdraw] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const accountStatement = async () => {
    try {
      const response = await axios.get(base_url + '/api/webapi/accountStatement', {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const accountStmt = response?.data.accountStmt || [];
      const account = response?.data.account || [];
      const accwithdraw = response?.data.accwithdraw || [];

      setAllStatement(accountStmt);
      setAllRecharge(account);
      setAllWithdraw(accwithdraw);

      // Show all data by default
      setStatement(accountStmt);
      setRecharge(account);
      setWithdraw(accwithdraw);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn("User might be logged out or endpoint not found.");
        setStatement([]);
        setRecharge([]);
        setWithdraw([]);
        return;
      }
      console.error("Error fetching account statement:", error);
    }
  };

  useEffect(() => {
    accountStatement();
  }, []);

  const applyDateFilter = () => {
    if (!startDate && !endDate) {
      setStatement(allStatement);
      setRecharge(allRecharge);
      setWithdraw(allWithdraw);
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999); // Include entire end day

    const filterByDate = (dateStr) => {
      const dateOnlyStr = dateStr.split(' ')[0]; // Get YYYY-MM-DD
      const dateOnly = new Date(dateOnlyStr);
      return dateOnly >= start && dateOnly <= end;
    };

    const filteredStatement = allStatement.filter(item => filterByDate(item.time));
    const filteredRecharge = allRecharge.filter(item => filterByDate(item.today));
    const filteredWithdraw = allWithdraw.filter(item => filterByDate(item.today));

    setStatement(filteredStatement);
    setRecharge(filteredRecharge);
    setWithdraw(filteredWithdraw);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Account Statement", 14, 10);

    const allRows = [];

    statement.forEach((ele) => {
      allRows.push([
        `Chips ${ele.type === "debit" ? "Withdrawal" : "Deposit"} By ${ele.providerName}\n${new Date(ele.time).toLocaleString('en-IN', {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        })}`,
        ele.amount,
        ele.main_balance
      ]);
    });

    recharge.forEach((ele) => {
      allRows.push([
        `Chips Deposit By Self\n${ele.today}`,
        ele.money,
        ele.balance
      ]);
    });

    withdraw.forEach((ele) => {
      allRows.push([
        `Chips Withdraw By Self\n${ele.today}`,
        ele.money,
        ele.balance
      ]);
    });

    autoTable(doc, {
      head: [["Narration", "Amount", "Balance"]],
      body: allRows,
      startY: 20
    });

    doc.save("account_statement.pdf");
  };

  return (
    <>
      <div className="mt-3 px-4">
        <form className="row">
          <div className="col-lg-3">
            <p>Start Date:</p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-control date-input bets-form-bg border-warning"
            />
          </div>

          <div className="col-lg-3">
            <p>End Date:</p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="form-control date-input bets-form-bg border-warning"
            />
          </div>

          <div className="col-lg-3 d-flex align-items-end mt-2">
            <button
              type="button"
              className="p-2 rounded-2 w-100 load-btn btn btn-warning"
              onClick={applyDateFilter}
            >
              Load Report
            </button>
          </div>

          <div className="col-lg-3 d-flex align-items-end mt-2">
            <button
              type="button"
              className="p-2 rounded-2 w-100 btn btn-success"
              onClick={downloadPDF}
            >
              Download PDF
            </button>
          </div>
        </form>
      </div>

      <table className="table w-100">
        <thead>
          <tr className="p-2 border">
            <th className="text-start text-nowrap border px-3">Narration</th>
            <th className="text-center text-nowrap border px-3">Amount</th>
            <th className="text-center text-nowrap border px-3">Balance</th>
          </tr>
        </thead>
        <tbody style={{ background: '#000' }}>
          {statement.map((ele, index) => (
            <tr key={`stmt-${index}`} className="border">
              <td className="text-start text-nowrap px-2">
                <b>
                  <div>
                    <div>{ele.type === "debit" ? "Withdrawal" : "Deposit"} By {ele.providerName}</div>
                    <div>
                      {new Date(ele.time).toLocaleString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      })}
                    </div>
                  </div>
                </b>
              </td>
              <td className="text-center text-nowrap px-2">
                <b style={{ color: ele.type === "debit" ? "red" : "#7eff7e" }}>
                  {ele.amount}
                </b>
              </td>
              <td className="text-center text-nowrap px-2" style={{ minWidth: "190px" }}>
                <b>{ele.main_balance}</b>
              </td>
            </tr>
          ))}

          {recharge.map((ele, index) => (
            <tr key={`recharge-${index}`} className="border">
              <td style={{ fontSize: "14px" }} className="text-start text-nowrap px-2">
                <b>
                  <div>
                    <div>Chips Deposit By Self</div>
                    <div>{ele.today}</div>
                  </div>
                </b>
              </td>
              <td style={{ fontSize: "14px" }} className="text-center text-nowrap px-2">
                <b style={{ color: ele.status === 2 ? "red" : "green" }}>
                  {ele.money}
                </b>
              </td>
              <td className="text-center text-nowrap px-2" style={{ minWidth: "190px", fontSize: "14px" }}>
                <b>{ele.balance}</b>
              </td>
            </tr>
          ))}

          {withdraw.map((ele, index) => (
            <tr key={`withdraw-${index}`} className="border">
              <td style={{ fontSize: "14px" }} className="text-start text-nowrap px-2">
                <b>
                  <div>
                    <div>Chips Withdraw By Self</div>
                    <div>{ele.today}</div>
                  </div>
                </b>
              </td>
              <td style={{ fontSize: "14px" }} className="text-center text-nowrap px-2">
                <b style={{ color: ele.status === "2" ? "red" : "green" }}>
                  {ele.money}
                </b>
              </td>
              <td className="text-center text-nowrap px-2" style={{ minWidth: "190px", fontSize: "14px" }}>
                <b>{ele.balance}</b>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};


const Result = () => { // Receive data as prop

  // const sportData = data && data.length > 0 ? data : [];
    // const main_balance=data & data.length>0? data:[];
  // console.log("Anshul sport data is ", sportData);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Fancy Tennis");
    const [history, setHistory]= useState([]);
    const [fancyFetchHistory , setFancyFetchHistory] = useState([])
  
  const options = ["Fancy Tennis", "Cricket", "Casino"];
  
  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);}
  
      const fethcHistory= async()=> {
          
            const response= await axios.get(base_url + '/api/webapi/betMatchHistory',

                {   withCredentials:true,
                    headers:{
                        Accept:'application/json',
                       
                    }
                }
            )
            // console.log('airh',response.data);
            const hist= response.data.matchHistory;
            // console.log('jiys ghvduhguydb',hist);
            if(response?.data.success){
                setHistory(hist);
            }


            const response2 = await axios.get(base_url + '/api/webapi/betFancyMatchHistory', {
              withCredentials: true,
              headers: {
                Accept: 'application/json',
              },
            });
      
            console.log('API response:', response2.data);
      
            const hist2 = response2.data.matchHistory; // Use response2, not response
            console.log('Fetched History:', hist2);
      
            if (response2.data.success) {
              setFancyFetchHistory(hist2);
            }

        }



    
        useEffect(()=>{
          window.scrollTo(0,0);
            fethcHistory();
            // console.log(history);
        },[]);

        // console.log("Hostory is " , history)
  
  // console.log(sportData,"cfghvbhjklm;")
  return (
      <>
          <div className="mt-3 ">
          <form className="form-container" style={{display: 'flex',  backgroundColor: '#fff', padding: '10px', gap: '10px', width: '100%'}}>
  {/* Filter Type Dropdown */}
  {/* <div style={{flex: 3}}>
    <p style={{color: 'black', fontSize: '14px', marginBottom: '8px'}}>Filter Type</p>
    <select style={{width: '100%', backgroundColor: 'white', color: 'black', border: '2px solid #ffd800', padding: '10px', borderRadius: '2px', appearance: 'auto'}}>
      <option>SETTLED</option>
      <option>MATCHED</option>
      <option>CANCEL</option>
      <option>VOIDED</option>
      <option>LAPSED</option>
      <option>UN-MATCHED</option>
    </select>
  </div>
   <div style={{flex: 2}}>
      <p style={{color: 'black', fontSize: '14px', marginBottom: '8px'}}> Filter Type</p>
      <div style={{display: 'flex', gap: '10px'}}>
        <div style={{position: 'relative', flex: 1}}>
          <div
            onClick={() => setIsOpen(!isOpen)}
            style={{
              width: '100%', 
              backgroundColor: 'white', 
              color: 'black', 
              border: '1.5px solid #ffd800', 
              padding: '10px', 
              borderRadius: '2px', 
              paddingRight: '30px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer'
            }}
          >
            <span>{selected}</span>
            <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
              <ChevronDown size={16} color="white" style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease'
              }} />
            </span>
          </div>
          
          {isOpen && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: '#212121',
              borderRadius: '2px',
              marginTop: '2px',
              zIndex: 10,
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              {options.map((option) => (
                <div
                  key={option}
                  onClick={() => handleSelect(option)}
                  style={{
                    padding: '10px',
                    color: 'white',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseEnter={(e) => { e.target.style.backgroundColor = '#2c2c2c' }}
                  onMouseLeave={(e) => { e.target.style.backgroundColor = '#212121' }}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div> */}

  {/* Start Date & Time */}
  {/* <div style={{flex: 4}}>
    <p style={{color: 'black', fontSize: '14px', marginBottom: '8px'}}> Date & Time:</p>
    <div style={{display: 'flex', gap: '10px'}}>
      <div style={{position: 'relative', flex: 1}}>
        <input
          type="text"
          defaultValue="04-04-2025"
          placeholder="dd-mm-yyyy"
          style={{width: '100%', backgroundColor: 'white', color: 'black', border: '1px solid #ffd800', padding: '10px', borderRadius: '2px', paddingRight: '30px'}}
        />
        <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z" stroke="white" strokeWidth="1.5"/>
            <path d="M11 1v3M5 1v3M2 6h12" stroke="white" strokeWidth="1.5"/>
          </svg>
        </span>
      </div>
      <div style={{position: 'relative', flex: 1}}>
        <input
          type="text"
          defaultValue="10:48:21"
          style={{width: '100%', backgroundColor: 'white', color: 'black', border: '1px solid #ffd800', padding: '10px', borderRadius: '2px', paddingRight: '30px'}}
        />
        <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6.5" stroke="white" strokeWidth="1.5"/>
            <path d="M8 4v4l3 2" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </span>
      </div>
    </div>
  </div> */}

  {/* End Date & Time */}
  {/* <div style={{flex: 3.5}}>
    <p style={{color: 'white', fontSize: '14px', marginBottom: '8px'}}>End Date & Time:</p>
    <div style={{display: 'flex', gap: '10px'}}>
      <div style={{position: 'relative', flex: 1}}>
        <input
          type="text"
          defaultValue="10-04-2025"
          placeholder="dd-mm-yyyy"
          style={{width: '100%', backgroundColor: '#212121', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', paddingRight: '30px'}}
        />
        <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z" stroke="white" strokeWidth="1.5"/>
            <path d="M11 1v3M5 1v3M2 6h12" stroke="white" strokeWidth="1.5"/>
          </svg>
        </span>
      </div>
      <div style={{position: 'relative', flex: 1}}>
        <input
          type="text"
          defaultValue="10:48:21"
          style={{width: '100%', backgroundColor: '#212121', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', paddingRight: '30px'}}
        />
        <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6.5" stroke="white" strokeWidth="1.5"/>
            <path d="M8 4v4l3 2" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </span>
      </div>
    </div>
  </div> */}

  {/* Load Report Button */}
  {/* <div style={{flex: 2,marginTop:"28px"}}>
    <button style={{width: '100%', backgroundColor: '#ffd800', color: '#black', border: 'none', borderRadius: '2px', padding: '10px', fontWeight: 'bold', cursor: 'pointer'}}>
      Load Report
    </button>
  </div> */}
</form>
          </div>
          <table className="table-responsive-sm table-responsive-md w-100 bg-white">
  <thead>
    <tr className="p-2 bb" style={{height:"40px"}}>
      <th className="text-start text-nowrap border px-3 bb pl-2">Competition Name</th>
      <th className="text-start text-nowrap border px-3 bb">Event Name</th>
      <th className="text-start text-nowrap border px-3 bb">Market Name</th>
      <th className="text-start text-nowrap border px-3 bb">Results</th>
    </tr>
  </thead>
 <tbody>
  {history && history.length > 0 ? (
    history.map((ele, index) => {
      const match = ele.match?.[0]; // safely get the first match
      return (
        <tr key={`match-${index}`} className="border bg-white" style={{ height: "40px" , fontSize:"14px" }}>
          <td className="text-start text-nowrap px-2 bb">{match?.competitionname || "N/A"}</td>
          <td className="text-start text-nowrap px-2 bb">{match?.eventname || "N/A"}</td>
          <td className="text-start text-nowrap px-2 bb">{match?.marketname || "N/A"}</td>
          <td className="text-start text-nowrap px-2 bb">
            {match?.result ? match.result : "Pending"}
          </td>
        </tr>
      );
    })
  ) : null}

  {fancyFetchHistory && fancyFetchHistory.length > 0 ? (
    fancyFetchHistory.map((ele, index) => (
      <tr key={`fancy-${index}`} className="border bg-white" style={{ height: "40px" , fontSize : "14px" }}>
        <td className="text-start text-nowrap px-2 bb">{ele.competitionName || "N/A"}</td>
        <td className="text-start text-nowrap px-2 bb">{ele.eventName || "N/A"}</td>
        <td className="text-start text-nowrap px-2 bb">{ele.runnerName || "N/A"}</td>
        <td className="text-start text-nowrap px-2 bb">{ele.result || "Pending"}</td>
      </tr>
    ))
  ) : null}

  {history.length === 0 && fancyFetchHistory.length === 0 && (
    <tr>
      <td colSpan="4" className="text-center">No data available</td>
    </tr>
  )}
</tbody>

</table>

      </>
  );
};

export default SportsBets;